/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Question } from '@/types'

const athenaOptions = {
  'Patient Demographics': [
    { value: 'patients.first_name', label: 'First Name' },
    { value: 'patients.middle_name', label: 'Middle Name' },
    { value: 'patients.last_name', label: 'Last Name' },
    { value: 'patients.alt_first_name', label: 'First Name Used' },
    { value: 'patients.email', label: 'Email' },
    { value: 'patients.date_birth', label: 'Date of Birth' },
    { value: 'patients.sex_at_birth', label: 'Legal Sex*' },
    { value: 'patients.gender', label: 'Gender Identity*' },
    { value: 'patients.phone_number', label: 'Mobile Phone Number' },
    { value: 'patients.home_phone_number', label: 'Home Phone Number' },
    { value: 'patients.work_phone_number', label: 'Work Phone Number' },
    { value: 'patients.marital_status', label: 'Marital Status*' },
    {
      value: 'patients.emergency_contact_name',
      label: 'Emergency Contact Name',
    },
    {
      value: 'patients.emergency_contact_phone',
      label: 'Emergency Contact Phone Number',
    },
    {
      value: 'patients.emergency_contact_relationship',
      label: 'Emergency Contact Relationship*',
    },
    { value: 'patients.address', label: 'Address' },
    { value: 'patients.address2', label: 'Address 2' },
    { value: 'patients.city', label: 'City' },
    { value: 'patients.state', label: 'State' },
    { value: 'patients.zipcode', label: 'Zipcode' },
    { value: 'patients.notes', label: 'Notes' },
    { value: 'patients.ssn', label: 'SSN' },
  ],
  Reports: [],
}

export const conditionalAthenaOptionsValue = (
  question: Question | undefined,
  key: string,
  includeFullName = false
) => {
  if (question?.question_type?.question_subtype === 'full_name') {
    // @ts-ignore
    let options = athenaOptions[key].map((e: any) => {
      if (e.value === 'patients.first_name') {
        return {
          label: 'Full Name',
          value: 'patients.full_name#first_name:middle_name:last_name',
        }
      }

      return e
    })
    options = options.filter(
      (e: any) =>
        e.value !== 'patients.middle_name' && e.value !== 'patients.last_name'
    )

    return options
  } else if (includeFullName && key === 'Patient Demographics') {
    return [
      {
        label: 'Full Name',
        value: 'patients.full_name#first_name:middle_name:last_name',
      },
      // @ts-ignore
      ...athenaOptions[key],
    ]
  }

  // @ts-ignore
  return athenaOptions[key]
}
export default athenaOptions
